import slink from 'src/router/middleware/authentification/slink.js'
import loginRedirect from 'src/router/middleware/authentification/loginRedirect.js'
import redirectLoginSign from 'src/router/middleware/authentification/redirectLoginSign.js'
import fetchSchoolBySlink from 'src/router/middleware/authentification/fetchSchoolBySlink.js'
import ssoRedirect from 'src/router/middleware/authentification/ssoRedirect.js'
import checkAuthenticator from 'src/router/middleware/authentification/authenticator.js'

// Keep critical routes for login/logout synchronous, to avoid chunk loading errors
import LoginStart from 'src/views/Miscellaneous/Start/Start.vue'
import Redirect from 'src/views/Miscellaneous/Redirect.vue'
import LoginSignIn from 'src/views/Authentification/Login/LoginSignIn.vue'
import LoginSelectSchool from 'src/views/Authentification/Login/LoginSelectSchool.vue'
import LoginContainer from 'src/views/Authentification/Login/LoginContainer.vue'

const LoginForgotData = () => import('src/views/Authentification/Login/LoginForgotData.vue')
const LoginLostData = () => import('src/views/Authentification/Login/LoginLostData.vue')
const LoginPasswordReset = () => import('src/views/Authentification/Login/LoginPasswordReset.vue')
const LoginAddUser = () => import('src/views/Authentification/Login/LoginAddUser.vue')
const MarkingSchoolInfo = () => import('src/views/Miscellaneous/Marketing/MarketingSchoolInfo.vue')
const MarketingRegisterSchool = () => import('src/views/Miscellaneous/Marketing/MarketingRegisterSchool.vue')
const MarketingChooseUserType = () => import('src/views/Miscellaneous/Marketing/MarketingChooseUserType.vue')
const MarketingSuccessfull = () => import('src/views/Miscellaneous/Marketing/MarketingSuccessfull.vue')
const SSOVerify = () => import('src/views/Authentification/Login/SingleSignOn/SSOVerify.vue')
const AuthenticatorContainer = () => import('src/views/Authentification/2FA/AuthenticatorContainer.vue')
const Authenticator = () => import('src/views/Authentification/2FA/Authenticator.vue')
const AddNewCode = () => import('src/views/Authentification/2FA/AddNewCode.vue')
const CreateBackup = () => import('src/views/Authentification/2FA/CreateBackup.vue')
const RestoreBackup = () => import('src/views/Authentification/2FA/RestoreBackup.vue')
const ScanQR = () => import('src/views/Authentification/2FA/ScanQR.vue')
const SetupKey = () => import('src/views/Authentification/2FA/SetupKey.vue')
const PostLogout = () => import('src/views/Close/PostLogout.vue')
const OidcCallback = () => import('src/views/Authentification//Login/SingleSignOn/OidcCallback.vue')
const routes = [
  {
    path: '/',
    component: LoginStart,
    name: 'login-start',
    meta: {
      isPublic: true,
      middleware: [loginRedirect],
      layout: 'SduiAuthenticator',
      enableSwHotReload: true,
      group: 'login'
    }
  },
  {
    path: '/post-logout',
    component: PostLogout,
    name: 'pre-close',
    meta: {
      isPublic: true,
      middleware: null,
      group: 'logout',
      transitionPoint: 1
    }
  },
  {
    path: '/select-school/:keyword?',
    component: LoginSelectSchool,
    name: 'login-select-school',
    meta: {
      isPublic: true,
      enableSwHotReload: true,
      middleware: null,
      headerText: 'global.headers.select_school'
    }
  },
  {
    path: '/login/:slink/forgot',
    component: LoginForgotData,
    name: 'login-forgot-data',
    meta: {
      isPublic: true,
      middleware: [fetchSchoolBySlink],
      group: 'login',
      transitionPoint: 4,
      headerText: 'global.headers.reset_password'
    }
  },
  {
    path: '/login/:slink/lost',
    component: LoginLostData,
    name: 'login-lost-data',
    meta: {
      isPublic: true,
      middleware: [fetchSchoolBySlink],
      group: 'login',
      transitionPoint: 6
    }
  },
  {
    path: '/login/:slink/password-reset',
    component: LoginPasswordReset,
    name: 'login-password-reset',
    meta: {
      isPublic: true,
      middleware: null,
      group: 'login'
    }
  },

  // marketing
  {
    path: '/school/info/user-type/:uuid',
    name: 'marketing-user-type',
    component: MarketingChooseUserType,
    meta: {
      isPublic: true,
      middleware: null,
      group: 'login',
      transitionPoint: 3
    }
  },

  {
    path: '/school/page/info/:type/:uuid',
    name: 'marketing-school-info',
    component: MarkingSchoolInfo,
    meta: {
      isPublic: true,
      middleware: null,
      group: 'login',
      transitionPoint: 3
    }
  },

  {
    path: '/login/add/user',
    name: 'login-add-user',
    component: LoginAddUser,
    meta: {
      isPublic: false,
      middleware: null,
      headerText: 'global.headers.add_account'
    }
  },

  {
    path: '/school/page/info/:type/:uuid/register',
    name: 'marketing-register-school',
    component: MarketingRegisterSchool,
    meta: {
      isPublic: true,
      middleware: null,
      group: 'login',
      transitionPoint: 3
    }
  },

  {
    path: '/school/page/info/:type/:uuid/register/confirmed',
    name: 'marketing-register-confirmed',
    component: MarketingSuccessfull,
    meta: {
      isPublic: true,
      middleware: null,
      group: 'login',
      transitionPoint: 3
    }
  },

  {
    path: '/redirect',
    component: Redirect,
    name: 'sdui-redirect-page',
    meta: {
      isPublic: true
    }
  },

  /*********************/
  /** sso-verify **/
  /*********************/
  // To ensure a consistent and reliable trigger for the deeplink, we are introducing this route that will redirect to a fresh subdomain.
  // Triggering the deeplink on iOS devices. Only iOS users will land on this route because of the logic implemented on the ios native app.
  // More info at:https://miro.com/app/board/uXjVM6Hvz9U=/?moveToWidget=3458764560223598488&cot=14
  {
    path: '/sso-verify/ios/:slink',
    name: 'sso-verify-ios',
    meta: {
      isPublic: true
    }
  },
  {
    path: '/sso-verify/:slink',
    name: 'sso-verify',
    component: SSOVerify,
    meta: {
      isPublic: true,
      // TODO: fix issue with order of orders of middlewares
      middleware: [ssoRedirect, slink] // no redirectLoginSign needed, due to reload in the process
    }
  },

  /*********************/
  /** login container **/
  /*********************/
  {
    path: '/:slink/login',
    component: LoginContainer,
    children: [
      {
        path: '',
        name: 'login-sign-in',
        component: LoginSignIn,
        meta: {
          isPublic: true,
          middleware: [slink, redirectLoginSign],
          layout: 'SduiAuthenticator',
          group: 'login',
          enableSwHotReload: true,
          forceAggressiveScreenReaderFocus: true,
          transitionPoint: 3
        }
      }
    ]
  },
  /*********************/
  /** 2fa **/
  /*********************/
  // legacy path forwarding, easily dropable after 08.01.2025 (new school year)
  {
    path: '/:slink/authenticator',
    children: [
      {
        path: '',
        redirect: '/authenticator/start'
      },
      {
        path: 'start',
        redirect: '/authenticator/start'
      }
    ]
  },
  {
    path: '/authenticator',
    component: AuthenticatorContainer,
    meta: {
      isPublic: true,
      group: '2fa',
      middleware: null
    },
    children: [
      {
        path: 'start',
        name: 'authenticator-start',
        component: Authenticator,
        meta: {
          middleware: [checkAuthenticator],
          transitionPoint: 1,
          layout: 'SduiAuthenticator',
          group: '2fa'
        }
      },
      {
        path: 'add',
        name: 'add-new-code',
        component: AddNewCode,
        meta: {
          middleware: [checkAuthenticator],
          transitionPoint: 2
        }
      },
      {
        path: 'backup',
        name: 'authenticator-create-backup',
        component: CreateBackup,
        meta: {
          middleware: [checkAuthenticator],
          transitionPoint: 2
        }
      },
      {
        path: 'restore',
        name: 'authenticator-restore-backup',
        component: RestoreBackup,
        meta: {
          middleware: [checkAuthenticator],
          transitionPoint: 2
        }
      },
      {
        path: 'scan',
        name: 'authenticator-scan-qr',
        component: ScanQR,
        meta: {
          middleware: [checkAuthenticator],
          transitionPoint: 3
        }
      },
      {
        path: 'setup-key',
        name: 'authenticator-setup-key',
        component: SetupKey,
        meta: {
          middleware: [checkAuthenticator],
          transitionPoint: 3
        }
      }
    ]
  },
  /*********************/
  /** Keycloak OIDC **/
  /*********************/
  {
    path: '/callback',
    name: 'keycloak-oidc-callback',
    component: OidcCallback,
    meta: {
      isPublic: true,
      group: 'SingleSignOn',
      middleware: null
    },

  }
]

export default routes
